import StreetviewRoundedIcon from '@mui/icons-material/StreetviewRounded';

export default function StreetObservations() {
  return (
    <div className="agents-section" dir="rtl">
      <header className="agents-section-head">
        <div><h2>مشاهدات خیابانی</h2><p>ثبت کیفیت مسیر، روشنایی و دسترسی‌های محلی</p></div>
      </header>
      <div className="agents-empty-state">
        <span><StreetviewRoundedIcon /></span>
        <h3>مشاهدات سطح خیابان</h3>
        <p>اطلاعات پارکینگ، روشنایی، کیفیت سطح و دسترسی خیابان‌ها در این بخش ثبت خواهد شد.</p>
        <small>به‌زودی در دسترس</small>
      </div>
    </div>
  );
}
